export default __webpack_public_path__ + "static/logo-6929b619bb7e998594f5ab125e36d542.jpg";